import React from 'react'

export default ({ children, ...props }) => children(props)
